import { useAppSelector } from "@config/hooks";
import { EUserRoles } from "@models/user";

/**
 * SECURITY: role source of truth is Redux `state.auth.currentUser`, populated
 * from BE login response. `localStorage.getItem("USER_ROLE")` was legacy dead
 * code (nothing ever wrote that key) and silently allowed any role through
 * every STORE_OWNER guard that read it — see PC011 UTC-TC003.
 */
export const useCurrentUserRole = () => {
  const currentUser = useAppSelector((state) => state.auth.currentUser);
  return currentUser?.role?.[0]?.roleCode as EUserRoles | undefined;
};
